/**
 * Parte o texto `incidencia_rubrica` do z_* / sumarização.
 * Formato legado (fn_esocial): "descrição - categoria".
 * Fixtures/legado ocasional: "11 - Mensal" (código - rótulo).
 *
 * @param {string|null|undefined} texto
 * @returns {{ codigo: string|null, descricao: string|null, categoria: string|null }}
 */
export function partesIncidenciaRubrica(texto) {
  const raw = texto != null ? String(texto).trim() : "";
  if (!raw) {
    return { codigo: null, descricao: null, categoria: null };
  }

  const sep = " - ";
  const i = raw.indexOf(sep);
  if (i < 0) {
    return { codigo: null, descricao: raw, categoria: null };
  }

  const left = raw.slice(0, i).trim();
  const right = raw.slice(i + sep.length).trim();

  if (/^\d+$/.test(left)) {
    return { codigo: left, descricao: right || null, categoria: null };
  }

  return {
    codigo: null,
    descricao: left || null,
    categoria: right || null,
  };
}
